import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  title: {
    id: 'report.title',
    defaultMessage: 'Zeckit-selvitys',
    description: 'Report main title.',
  },
});
